import React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const isBeforeToday = (d) => d < new Date(new Date().setHours(0, 0, 0, 0));

const DatePickerField = ({ date, setDate, placeholder, testid }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        data-testid={testid}
        type="button"
        className="w-full h-12 border border-[#1A1F24]/20 px-3 flex items-center gap-2 text-sm bg-white hover:bg-[#F9F6F0] transition-colors"
      >
        <CalendarIcon className="w-4 h-4 text-[#4A5568]" />
        <span className={date ? "text-[#1A1F24]" : "text-[#A0AEC0]"}>
          {date ? format(date, "PPP") : placeholder}
        </span>
      </button>
    </PopoverTrigger>
    <PopoverContent className="w-auto p-0" align="start">
      <Calendar
        mode="single"
        selected={date}
        onSelect={setDate}
        disabled={isBeforeToday}
        initialFocus
      />
    </PopoverContent>
  </Popover>
);

export default DatePickerField;
